import { isCustomColumn } from '~/models/query';

export default class QueryColumnsController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 */
	constructor($translate) {
		this.$translate = $translate;

		/** @type {any[]} */
		this.columns = [];

		/** @type {any} */
		this.classRepresentations = {};

		/** @type {any} */
		this.root = undefined;

		/** @type {?import('angular').INgModelController} */
		this.ngModelCtrl = null;

		this.defaultValue = [
			{
				lang: {
					kid: 'default',
				},
				label: 'Par défaut',
			},
			{
				lang: {
					kid: 'custom',
				},
				label: 'Personnalisé',
			},
		];
	}

	/**
	 * Adds a column
	 *
	 * @param {any} item columns details
	 * @returns {any} select object
	 */
	addSelect(item) {
		let select = item;
		const separator = item.flow === 'up' ? '◀' : '▶';

		if (!('op' in item)) {
			select = {
				inherits_extended: 'inherits_extended' in item ? item.inherits_extended : -1,
				kid:               item.node,
				isa:               item.isa,
				linker_kid:        item.linker_kid,
				name:              item.name,
				node:              'REPRE',
				op:                'detail',
				path:              item.path,
				type:              item.type,
			};

			if (this.isCustomColumn(item.formatter)) {
				select.kid = this.root.node;
				select.path = this.root.path;
				select.type = item.formatter;
			}

			if ('linker_info' in item) {
				select.linker_info = item.linker_info;
			}

			if ('includeInQuery' in item) {
				select.includeInQuery = item.includeInQuery;
			}

			if ('from' in item) {
				select.from = item.from;
			}

			if (!Array.isArray(this.columns)) {
				this.columns = [];
			}

			// Vérif nom en double dans les autres colonnes
			for (const [ks, s] of this.columns.entries()) {
				if (
					s.name === select.name
					&& s.linker_kid === select.linker_kid
					&& s.path?.length > 1
					&& select.path?.length > 1
					&& !s.name.includes('▶')
					&& !s.name.includes('◀')
				) {
					this.columns[ks].name = `${s.path.at(-2).name} ${separator} ${s.name}`;
					select.name = `${select.path.at(-2).name} ${separator} ${select.name}`;
				}
			}
		}

		this.ngModelCtrl?.$setViewValue(this.columns);

		return select;
	}

	/**
	 * Check if a column is a custom column
	 *
	 * @param {*} column
	 * @returns {boolean} Returns true if it is a custom column
	 */
	// eslint-disable-next-line class-methods-use-this
	isCustomColumn(column) {
		return isCustomColumn(column);
	}

	/**
	 * Returns an array of class representations for the given id.
	 *
	 * @param {string} id - The id of the class.
	 * @returns {any[]} - An array of class representations.
	 */
	// eslint-disable-next-line no-unused-vars
	getClassRepresentations(id) {
		// if (this.classRepresentations && this.classRepresentations[id]) {
		// 	result.push(...this.classRepresentations[id]);
		// }

		return this.defaultValue;
	}
}
